(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/common/assets/javascripts/logger.js') >= 0) return;  svs.modules.push('/components/payment/common/assets/javascripts/logger.js');
'use strict';

const {
  log
} = svs.core;
const logger = log.getLogger('lb:payment');
setGlobal('svs.components.payment.common.logger', logger);

 })(window);